import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LiveHelp from "@material-ui/icons/LiveHelpTwoTone";
import Store from "@material-ui/icons/StoreTwoTone";
// material-ui
import { withStyles } from "@material-ui/styles";
// custom
import SurveyCard from "components/SurveyCard";
import { MARKET } from "constants/routes";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class SurveysList extends Component {
  static propTypes = {
    classes: PropTypes.object,
    history: PropTypes.object,
    surveys: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedSurvey) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedSurvey);
    }
  }

  render() {
    const { surveys, history, classes } = this.props;

    if (surveys.length === 0) {
      return (
        <Grid
          container
          justify="center"
          alignItems="center"
          direction="column"
          style={{ height: "100%", textAlign: "center" }}
        >
          <Grid item>
            <LiveHelp
              style={{ fontSize: 70 }}
              className={classes.darkModeFix}
            />
          </Grid>
          <Grid item>
            <Typography display="block" variant="h6">
              No Assessments.
            </Typography>
            <Typography display="block" variant="body" color="secondary">
              Visit the Market to Purchase Courses.
            </Typography>
            <Button
              color="primary"
              variant="outlined"
              style={{
                textTransform: "none",
                marginTop: 20,
              }}
              onClick={() => history.push(MARKET)}
            >
              <Store style={{ paddingRight: 10 }} /> Market
            </Button>
          </Grid>
        </Grid>
      );
    }

    return (
      <div>
        <Grid container spacing={2} alignItems="stretch">
          {surveys &&
            surveys.map((e) => (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <SurveyCard key={e.id} survey={e} history={history} />
              </Grid>
            ))}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(SurveysList);
